import * as angular from 'angular';

/**
 *
 * Force the element width to not exceed the iOS screen width
 * @param {angular.IAugmentedJQuery} $el
 */
export function clampElementWidthToAppleMobileBreakpoint($el: angular.IAugmentedJQuery): void {
  // only for iOS for now
  if (!iOS()) {
    return;
  }
  const landscape = window.orientation === 90 || window.orientation === -90;
  const { width, height } = window.screen;

  $el.width(landscape ? height : width);
}

/**
 * @inspiredby https://stackoverflow.com/a/9039885/1570065
 * @returns {boolean}
 */
export function iOS() {
  const iDevices = ['iPhone Simulator', 'iPod Simulator', 'iPhone', 'iPod'];

  if (!!window.navigator.platform) {
    return iDevices.indexOf(window.navigator.platform) >= 0;
  } else {
    return false;
  }
}
